export const getTelHref = (phone) => {
  const normalized = String(phone || '').trim().replace(/[^\d+]/g, '');
  return normalized ? `tel:${normalized}` : '';
};

export const getMailHref = (email) => {
  const normalized = String(email || '').trim();
  return normalized ? `mailto:${normalized}` : '';
};

export const getMapHref = (address) => {
  const query = String(address || '').trim();
  return query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : '';
};
